define('plugin/client-field/view/ClientFieldItemView',['require','plugin/additional-fields/view/AdditionalFieldItemView'],function (require) {

    var Parent = require('plugin/additional-fields/view/AdditionalFieldItemView');

    /**
     * Client field item view
     *
     * @class ClientFieldItemView
     */
    return Parent.extend({

        getTemplate: function () {
            return '#client_field_' + this.model.get('type');
        },
        
        //TODO why did I reimplement this method? 
        // setValue: function () {
        //     var val = this.ui.input.val();
        //     if (this.model.get('type') === 'checkbox') {
        //         val = this.ui.input.is(':checked');
        //     }
        // 
        //     if (this.model.get('type') === 'date') {
        //         if (this.ui.calendarToggle.length > 0) {
        //             val = this.ui.calendarToggleInput.val();
        //         }
        //     }
        // 
        //     this.model.set('value', val, {
        //         silent: true
        //     });
        // 
        //     this.triggerMethod('change');
        // },
        
        serializeData: function () {
            return _.extend({}, Parent.prototype.serializeData.apply(this), {
                'is_null': this.model.get('is_optional'),
                'error': this.getOption('error')
            });
        },
        
        getParentId: function () {
            return this.getOption('clientModel').id;
        },
        
    });

});
